import { get } from 'lodash'
import { required, dates } from 'utils/validation'

export default function(values = {}) {
  return {
    country: {
      id: required(get(values, 'country.id'))
    },
    awardUnit: {
      id: required(get(values, 'awardUnit.id'))
    },
    startDate: required(values.startDate),
    endDate: required(values.endDate) || dates(values.startDate)(values.endDate)
  }
}
